import { render, staticRenderFns } from "./SetsMemberWinLose.vue?vue&type=template&id=a05de272&"
import script from "./SetsMemberWinLose.vue?vue&type=script&lang=js&"
export * from "./SetsMemberWinLose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports